<template>
  <div>
    <div
      v-if="loading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <h3>Onboarding Customer</h3>
      </div>
    </div>
    <div v-else>
      <div class=" row align-items-center justify-content-between mb-2">
        <div class="col-auto">
          <h2 class=" font-regular">
            Onboarding Customer
          </h2>
        </div>
      </div>
      <div class="card">
        <div class="card-content card-body">
          <CDataTable :items="arr" :fields="fields" :itemsPerPage="10" sorter>
            <template #old_account_number="{item}">
              <td class="table--action-mobile">
                {{ item.existing_account_number }}
              </td>
            </template>
            <template #name="{item}">
              <td class="table--action-mobile">
                {{ item.first_name }} {{ " " }} {{ item.last_name }}
              </td>
            </template>
            <template #action="{item}">
              <td class="table--action-mobile">
                <router-link
                  :event="
                    permissions.includes('onboard-customer') ? 'click' : ''
                  "
                  class="button"
                  :class="
                    permissions.includes('onboard-customer')
                      ? ''
                      : 'disabled cursor-not-allowed'
                  "
                  :to="{
                    name: 'SingleOnboard',
                    params: { slug: item.hash }
                  }"
                >
                  View
                </router-link>
              </td>
            </template>
          </CDataTable>
          <CPagination
            :activePage.sync="next_page"
            :pages="total"
            :onActivePageChange="onPageChange()"
          ></CPagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../../services/api.service";
import CDataTable from "../../components/CDataTable.vue";

import CPagination from "../../components/CPagination.vue";
const fields = [
  "date",
  "phone_number",
  "name",
  "account_type",
  "bvn",
  "status",
  "old_account_number",
  "new_account_number",
  "existing_customer_number",
  "city",
  "action"
];

export default {
  name: "OnboardCustomer",
  components: {
    CDataTable,
    CPagination
  },
  data() {
    return {
      fields,
      loading: true,
      arr: [],
      next_page: 1,
      total: 1,
      current: 1
    };
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    }
  },
  methods: {
    async getCustomers() {
      try {
        const response = await ApiService.get(`onboarding/all?page=${this.next_page}`);
        console.log(response);
        this.arr = response.data.data.data;
        this.current = response.data.data.current_page;
        this.total = response.data.data.last_page;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    onPageChange() {
      console.log(this.next_page);
      if (this.current != this.next_page) {
        this.getCustomers(this.next_page);
      }
    }
  },
  mounted() {
    this.getCustomers();
  }
};
</script>

<style scoped></style>
